module.exports = __webpack_public_path__ + "img/index07.52d1a914.jpg";